import { createStore, compose, StoreEnhancer, applyMiddleware } from 'redux';
import { rootReducer, defaultState } from '../reducers';
import { ApplicationState } from '../reducers/types';
import { install, StoreCreator } from 'redux-loop';
import { activeMarketSyncMiddleware } from '../middleware/activeMarketSync';

const enhancedCreateStore = createStore as StoreCreator;

const enhancer: StoreEnhancer<ApplicationState> = (window as any)
  .__REDUX_DEVTOOLS_EXTENSION__
  ? compose(
      install(),
      applyMiddleware(activeMarketSyncMiddleware),
      (window as any).__REDUX_DEVTOOLS_EXTENSION__()
    )
  : compose(
      install(),
      applyMiddleware(activeMarketSyncMiddleware)
    );

const store = enhancedCreateStore(rootReducer, defaultState, enhancer);

export default store;
